import React, { useState, useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { AiFillEdit, AiOutlineRollback } from "react-icons/ai";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateDailyExpense,
  getDailyExpenseById,
  resetExpenseUpdate,
  resetExpenseDetails,
} from "../features/dailyexpense/dailyExpenseSlice";
import { toast } from "react-toastify";
import Loader from "../components/Loader";

const UpdateDailyExpense = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  // User Selector
  const { userInfo } = useSelector((state) => state.user);

  // Daily Expense Selector
  const {
    dailyExpense,

    isDetailsLoading,
    isDetailsError,
    detailsErrorMessage,
    isDetailsSuccess,

    isUpdateLoading,
    isUpdateError,
    updateErrorMessage,
    isUpdateSuccess,
  } = useSelector((state) => state.dailyExpense);

  // States
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");

  useEffect(() => {
    // console.log('userInfo: ', userInfo);
    if (!userInfo) {
      toast.error("Please Login to Get Access", { position: "top-center" });
      navigate("/login");
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    if (isDetailsError) {
      toast.error(detailsErrorMessage, { position: "top-center" });
    } else if (isDetailsSuccess) {
      setDescription(dailyExpense.description);
      setAmount(dailyExpense.amount);
    } else {
      dispatch(getDailyExpenseById(params.id));
    }
  }, [isDetailsError, isDetailsSuccess, detailsErrorMessage]);

  useEffect(() => {
    if (isUpdateError) {
      toast.error(updateErrorMessage, { position: "top-center" });
    } else if (isUpdateSuccess) {
      toast.success("Daily Expense Updated Successfully", {
        position: "top-center",
      });
      navigate("/dailyExpense");
    }
  }, [isUpdateError, isUpdateSuccess, updateErrorMessage]);

  useEffect(() => {
    return () => {
      dispatch(resetExpenseDetails());
      dispatch(resetExpenseUpdate());
    };
  }, [dispatch]);

  // Update Handler
  const updateHandler = (e) => {
    e.preventDefault();

    const dailyExpense = {
      description,
      amount,
    };
    dispatch(updateDailyExpense({ id: params.id, dailyExpense }));
  };

  return (
    <>
      {isDetailsLoading || isUpdateLoading ? (
        <Loader />
      ) : isDetailsError ? (
        <h4 variant="danger">{detailsErrorMessage}</h4>
      ) : (
        <Container fluid className="my-4">
          <Row className="mb-4">
            <Card
              className="rounded-4 border"
              style={{ backgroundColor: "#e6edf1" }}
            >
              <h2 className="my-3 text-dark text-center fw-bold">
                Update <span style={{ color: "#5c91dc" }}>Daily Expense</span>
              </h2>
            </Card>
          </Row>

          <Form>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <Card className="mb-4 shadow rounded">
                  <Card.Header
                    as="h5"
                    className="p-3 text-center text-black fw-bold"
                    style={{ backgroundColor: "#74a2e3" }}
                  >
                    Expense Entry
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="expenseAmount">
                          <Form.Label style={{ color: "black" }}>
                            Expense Amount
                          </Form.Label>
                          <Form.Control
                            required
                            type="number"
                            placeholder={
                              amount === ""
                                ? "Expense Amount is Required"
                                : "Enter Expense Amount"
                            }
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>

                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="description">
                          <Form.Label style={{ color: "black" }}>
                            Expense Description
                          </Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder={
                              description === ""
                                ? "Expense Description is Required"
                                : "State the Description"
                            }
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="px-3 mt-4 mb-1">
                      <Button
                        variant="outline-primary"
                        type="submit"
                        className="rounded"
                        onClick={updateHandler}
                      >
                        Update Expense
                      </Button>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form>
        </Container>
      )}
    </>
  );
};

export default UpdateDailyExpense;
